import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Header = _resolveComponent("Header");

  const _component_el_header = _resolveComponent("el-header");

  const _component_router_view = _resolveComponent("router-view");

  const _component_el_main = _resolveComponent("el-main");

  const _component_el_container = _resolveComponent("el-container");

  const _component_Footer = _resolveComponent("Footer");

  const _component_el_footer = _resolveComponent("el-footer");

  return _openBlock(), _createBlock(_component_el_container, {
    class: "con-lazy"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_header, null, {
      default: _withCtx(() => [_createVNode(_component_Header, {
        configData: _ctx.configData,
        productBarList: _ctx.productBarList
      }, null, 8, ["configData", "productBarList"])]),
      _: 1
    }), _createVNode(_component_el_container, null, {
      default: _withCtx(() => [_createVNode(_component_el_main, null, {
        default: _withCtx(() => [_createVNode(_component_router_view)]),
        _: 1
      })]),
      _: 1
    }), _createVNode(_component_el_footer, null, {
      default: _withCtx(() => [_createVNode(_component_Footer, {
        configData: _ctx.configData,
        productBarList: _ctx.productBarLists
      }, null, 8, ["configData", "productBarList"])]),
      _: 1
    })]),
    _: 1
  });
}